// @flow

import {
  getComponentSettings,
} from './main';

export {
  getButtonText as getCarBlockButtonText,
  getContractDurationAbbrv as getCarBlockContractDurationAbbrv,
  getDeliveryTime as getCarBlockDeliveryTime,
  getDeliveryTimeApproximately as getCarBlockDeliveryTimeApproximately,
  getDeliveryTimeDurationPlural as getCarBlockDeliveryTimeDurationPlural,
  getDeliveryTimeDurationSingle as getCarBlockDeliveryTimeDurationSingle,
  getMileageAbbrv as getCarBlockMileageAbbrv,
  getPriceDuration as getCarBlockPriceDuration,
  getPriceLabel as getCarBlockPriceLabel,
  getRoadtaxNote as getCarBlockRoadtaxNote,
  getContractPrefixText as getCarBlockContractPrefixText,
} from './carBlockSettings';
export type {
  CarBlockSettings,
} from './carBlockSettings';

export {
  getChooseACategoryText as getFAQCategoryListChooseACategoryText,
} from './faqCategoryListSettings';
export type {
  FAQCategoryListSettings,
} from './faqCategoryListSettings';

export {
  getFaqSearchFieldButtonText,
  getFaqSearchFieldInputPlaceholder,
} from './faqSearchFieldSettings';

export {
  getTitle,
  getFeedbackWasHelpful,
  getFeedbackWasNotHelpful,
  getFeedbackWasPartiallyHelpful,
} from './feedbackSettings';
export type { FeedbackSettings } from './feedbackSettings';

export {
  getCollapsibleButton as getListCollapsibleButton,
  getVisibleItemCount as getListVisibleItemCount,
} from './listSettings';
export type {
  ListSettings,
} from './listSettings';

export {
  getAddToComparisonText as getPdbCTAAddToComparisonText,
  getButtonText as getPdbCTAButtonText,
  getDeliveryTime as getPdbCTADeliveryTime,
  getDeliveryTimeApproximately as getPdbCTADeliveryTimeApproximately,
  getDeliveryTimeDurationPlural as getPdbCTADeliveryTimeDurationPlural,
  getDeliveryTimeDurationSingle as getPdbCTADeliveryTimeDurationSingle,
  getMaxItemsInComparison as getPdbCTAMaxItemsInComparison,
  getRemoveFromComparisonText as getPdbCTARemoveFromComparisonText,
  getFormData as getPdbCTAFormData,
} from './pdbCTASettings';
export type {
  CTASettings,
} from './pdbCTASettings';

export {
  getDisclaimerText as getPdbGalleryDisclaimerText,
  getTheaterButtonText as getPdbGalleryTheaterButtonText,
} from './pdbGallerySettings';
export type {
  GallerySettings,
} from './pdbGallerySettings';

export {
  getAvailableLabel as getPdbInfoAvailableLabel,
  getBasePriceLabel as getPdbInfoBasePriceLabel,
  getContractDurationAbbrv as getPdbInfoContractDurationAbbrv,
  getMileageAbbrv as getPdbInfoMileageAbbrv,
  getOccasionLinkTextPlural as getPdbInfoOccasionLinkTextPlural,
  getOccasionLinkTextSingle as getPdbInfoOccasionLinkTextSingle,
  getRoadtaxNote as getPdbInfoRoadtaxNote,
} from './pdbInfoSettings';
export type {
  InfoSettings,
} from './pdbInfoSettings';

export {
  getDoors as getPdbSpecificationDoors,
  getFuelInfo as getPdbSpecificationFuelInfo,
  getKeys as getPdbSpecificationKeys,
  getTitle as getPdbSpecificationTitle,
} from './pdbSpecificationSettings';
export type {
  SpecificationSettings,
} from './pdbSpecificationSettings';

export {
  getAllReviewsLinkText as getReviewAllReviewsLinkText,
  getBasedOn as getReviewBasedOn,
  getRating as getReviewRating,
  getReviewCount as getReviewReviewCount,
  getReviews as getReviewReviews,
  getScore as getReviewScore,
} from './reviewSettings';
export type {
  ReviewSettings,
} from './reviewSettings';

export {
  getCollapsibleButton as getWysiwygCollapsibleButton,
} from './wysiwygSettings';
export type {
  WysiwygSettings,
} from './wysiwygSettings';

export {
  getButtonText,
  getPriceLabel,
  getUniqueFeaturesLabel,
  getPackageSettings,
} from './pdbPackageSettings';

export default getComponentSettings;
